<button
    *ngIf="!href"
    type="button"
    [attr.aria-pressed]="selected"
    [linkId]="linkId"
    finderLinkId
    class="finder-button {{ theme }}"
    [ngClass]="{ 'selected': selected, 'full-width': fullWidth }"
    [attr.disabled]="disabled ? '' : null">
    <ng-container *ngTemplateOutlet="contentTpl"></ng-container>
</button>

<a
    *ngIf="href"
    type="button"
    [linkId]="linkId"
    finderLinkId
    finderLocale
    class="finder-button {{ theme }}"
    [ngClass]="{ 'fit-text': fitText, 'full-width': fullWidth }"
    [attr.disabled]="disabled ? '' : null"
    [attr.href]="href">
    <ng-container *ngTemplateOutlet="contentTpl"></ng-container>
</a>

<ng-template #contentTpl><ng-content></ng-content></ng-template>
